<template>
    <div class="container my-5">
        <div class="row">
            <div class="col-md-12 my-5">
                <error-404></error-404>
                <div class="text-center mt-3">
                    <router-link to="/" class="btn btn-primary px-5">
                        Home
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Error404 from '@/components/Error404.vue'
    export default {
        components: { Error404: Error404 },
        name: 'NotFound'
    }
</script>



// WEBPACK FOOTER //
// src/views/NotFound.vue